import React from 'react';
import PropTypes from 'prop-types';

import {Box, Heading, VStack} from '@salesforce/retail-react-app/app/components/shared/ui';

import {
  BuildAndCustomize,
} from '@amblique/king-living/app/components/product-view/variation-attributes-complex/build-and-customize';
import {ChooseYourSets} from '@amblique/king-living/app/components/product-view/variation-attributes-complex/choose-your-sets';
import {
  ProtectYourCover,
} from '@amblique/king-living/app/components/product-view/variation-attributes-complex/protect-your-cover';

/**
 * Variation Attributes Complex
 * Renders variation attributes for complex products.
 *
 * @param {object} props
 * @param {object} props.product
 * @param {boolean} props.isProductPartOfSet
 * @param {boolean} props.isProductPartOfBundle
 * @returns {React.ReactNode}
 */
export function VariationAttributesComplex({
  product,
  variationAttributes,
}) {
  return (
    <Box borderColor="gray.200" borderRadius="md" borderWidth={1} padding={4}>
      <VStack alignItems="stretch" spacing={4}>
        <Heading>Complex Variation Selection</Heading>

        <BuildAndCustomize />
        <ChooseYourSets />
        <ProtectYourCover product={product} />
      </VStack>
    </Box>
  );
}

VariationAttributesComplex.displayName = 'VariationAttributesComplex';

VariationAttributesComplex.propTypes = {
  product: PropTypes.object,
  variationAttributes: PropTypes.array,
};
